import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { Auth0Provider, Auth0ProviderOptions } from "@auth0/auth0-react";
import { useFlags, withLDProvider } from "launchdarkly-react-client-sdk";

import AppProvider from "./context/index";

import Routes from "./routes";
import i18next from "./i18n";
import history from "./utils/history";

export const onRedirectCallback = (appState: any) => {
  history.push(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
};
export const getLDRelayURL = () => {
  let env = "";
  const smilesDomain = window.location.hostname.indexOf("smiles.com.br") > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const isDotEnv = /^voebiz\.(.+)\.smiles\.com\.br$/.test(window.location.hostname);
  const res = rx.exec(window.location.hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    
    env = env.replace(/portal|voebiz/g, "").replace("uat", "hml");
    env = isDotEnv ? `.${env}` : `${env}`;
  } 

  if (window.location.hostname === "localhost") {
    // pra rodar local, descomentar pra subir
    env = "-dev1";
    // env = "-hml5";

  }

  return `https://ldrelay${env}.smiles.com.br`;
};

const clientSideId = "62baf3989195871574e35e6c";
const launchDarklyURL = getLDRelayURL();

function App() {
  const ldFlags = useFlags();

  const [providerConfig, setProviderConfig] = useState<Auth0ProviderOptions | undefined>(undefined);

  useEffect(() => {
    const { auth0Domain, auth0CliendId } = ldFlags;

    if (ldFlags.apiDomain) {
      setProviderConfig({
        domain: auth0Domain,
        clientId: auth0CliendId,
        audience: "https://voebiz.api",
        redirectUri: `${window.location.origin}/validar`,
        onRedirectCallback,
      });
    }
  }, [ldFlags]);

  if (providerConfig) {
    return (
      <Auth0Provider {...providerConfig}>
        <AppProvider>
          <I18nextProvider i18n={i18next}>
            <Routes />
          </I18nextProvider>
        </AppProvider>
      </Auth0Provider>
    );
  }
  return <div />;
}

export default withLDProvider({
  clientSideID: clientSideId,
  user: { key: window.location.origin },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App);
